export default function findCommonParent(node1, node2) {
    if (node1 && node2) {
        const parents = [];

        for (let n = node1; n; n = n.parentNode) {
            parents.push(n);
        }

        for (let n = node2; n; n = n.parentNode) {
            if (parents.indexOf(n) !== -1) {
                return n;
            }
        }
    }
    return null;
}
